module.exports = __webpack_public_path__ + "static/media/Spiral.cd893abf.png";